import React from "react";

const DocumentIcon = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={16} y1={13} x2={8} y2={13} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <line x1={16} y1={17} x2={8} y2={17} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <polyline points="10 9 9 9 8 9" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);

export default DocumentIcon;
